/***
 * Created on 2024/7/8
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {Suspense, useEffect} from 'react';
import {I18nextProvider} from "react-i18next";
import Header from '../component/header/header';
import HeaderSheet from "./header/mobile/header_sheet";
import Footer from '../component/footer';
import Router from "../component/router";
import GlobalAlert from "./global_alert";
import sharedI18n from "../i18n";

function AccMainApp(props) {
    const isAccount = () => {
        const uri = new URL(window.location.href);
        return uri.pathname.startsWith('/account')
    }

    useEffect(() => {
        const grecapcha = document.querySelector('.grecaptcha-badge');
        let observer;
        if (grecapcha) {
            if (!isAccount()) {
                grecapcha?.classList.remove('grecaptcha-badge')
            }
            else {
                grecapcha?.classList.add('grecaptcha-badge')
            }
        }
        else {
            observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.type === 'childList') {
                        if (mutation.target.firstChild?.className === 'grecaptcha-badge') {
                            if (!isAccount()) {
                                mutation.target.firstChild?.classList.remove('grecaptcha-badge')
                            } else {
                                mutation.target.firstChild?.classList.add('grecaptcha-badge')
                            }
                        }
                    }
                })
            });
            observer.observe(document.body, {childList: true, subtree: true});
        }

        return () => observer ? observer.disconnect() : "";
    }, [])

    useEffect(() => {
        const checkAlive = () => {
            fetch('/alive').then((response) => {
                if (response.ok) {
                    response.json().then((data) => {
                        console.log(data);
                        if (!data?.alive) {
                            window.location = '/signin';
                        }
                    });
                }
            }).catch((reason) => {
                console.log(reason);
            });
        }

        if (isAccount()) {
            window.addEventListener('focus', checkAlive);
        }

        return () => {
            window.removeEventListener('focus', checkAlive);
        }
    }, []);

    return (
        <>
            {/*<div className="modal-dialog"></div>*/}

            <div className="global-alert-wrapper">
                <GlobalAlert />
            </div>

            <div className="global-cookie-banner-wrapper"></div>

            <div className="comp-sheet-wrapper hide">
                <HeaderSheet />
            </div>

            <div className="app">
                <div className="app-root" data-app-layout={isAccount() ? '' : 'common'}>
                    <header className="app-head" data-z-index="top">
                        <Header />
                    </header>
                    {/*<nav className="app-nav ">*/}
                        <Router />
                    {/*</nav>*/}
                    {/*<main className="app-main">*/}
                    {/*</main>*/}
                    <footer className={`app-foot ${isAccount() ? 'hide' : ''}`}>
                        <Footer />
                    </footer>
                </div>
            </div>
        </>
    );
}

function AccManAppWrapper({}) {
    const Load = () => {
        return (<div className="comp-loading-indicator">
            <div className="loading-indicator--modern">
                <div className="loading-indicator__modern-wrapper loading-indicator__modern-wrapper--without-content">
                    <div className="loading-indicator__anime--circular">
                        <svg className="circular" viewBox="0 0 40 40">
                            <circle className="base" cx="20" cy="20" r="16" fill="none" strokeLinecap="round"
                                    strokeWidth="4" strokeMiterlimit="10"
                                    stroke="#e5e8eb"/>
                            <circle className="path" cx="20" cy="20" r="16" fill="none" strokeLinecap="round"
                                    strokeWidth="4"
                                    strokeMiterlimit="10" stroke="#001B49"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>)
    }
    return (
        <I18nextProvider i18n={sharedI18n}>
            <Suspense fallback={<Load />}>
                <AccMainApp/>
            </Suspense>
        </I18nextProvider>
    );
}

export default AccManAppWrapper;